<template>
  <div class="animated fadeIn" v-on:keyup.enter="InserirOuEditar">
    <b-row>
      <b-col sm="12">
        <div class="fright margin-5-bottom">
          <b-button variant="secondary" class="btn-square margin-5-right" @click="Voltar">Cancelar</b-button>
          <botao-duplo-clique variant="success" @click="InserirOuEditar" ref="botaoSalvar" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>Clientes </strong><small>{{ clienteId != null ? "Edição" : "Inserção" }}</small>
          </div>
          <b-row>
            <b-col>
              <validator prop-name="NomeCliente" :erros="erros" campo-descritivo="Razão Social">
                <b-form-input v-model="Razao" type="text" id="Razao" slot="component"
                  placeholder="Digite a razão social "></b-form-input>
              </validator>
            </b-col>
          </b-row>
          <validator prop-name="FantasiaCliente" :erros="erros" campo-descritivo="Nome fantasia">
            <b-form-input v-model="Fantasia" type="text" id="Fantasia" slot="component"
              placeholder="Digite o nome fantasia"></b-form-input>
          </validator>
          <b-row>
            <b-col sm="4">

              <validator prop-name="Cnpj" :erros="erros" campo-descritivo="Cnpj">
                <b-form-input v-model="cnpj" type="text" id="cnpj" slot="component" placeholder="Digite o CNPJ do cliente"
                  v-mask="'##.###.###/####-##'"></b-form-input>
              </validator>
            </b-col>
            <b-col sm="4">
              <label for="vat">Lança peso manual</label>
              <div>
                <c-switch class="mx-1" color="info" v-model="PesoManual" />
              </div>
            </b-col>
          </b-row>



        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
  
<script>
import { Switch as cSwitch } from '@coreui/vue'

export default {
  name: 'novo-cliente',
  components: {
    cSwitch
  },

  computed: {
    now() {
      var date = new Date()
      return date.toISOString().split('T')[0]
    },
    ClienteViewModel() {
      var vm = this

      return {
        Id: this.clienteId || this.$uuid.v4(),
        ContaId: this.$store.getters.getAutenticacao.contaId,
        UsuarioCadastroId: this.usuarioDeCadastroId,
        Cnpj: this.cnpj,
        nomeCliente: this.Razao,
        fantasiaCliente: this.Fantasia,
        PesoManual: this.PesoManual
      }
    }
  },
  created() {
    this.GetCliente()
    if (!this.clienteId) this.dataDeCadastro = this.now
  },
  data() {
    return {
      options: [],
      clienteId: this.$route.params.id || null,
      usuarioDeCadastro: this.$store.getters.getAutenticacao.apelido,
      usuarioDeCadastroId: this.$store.getters.getAutenticacao.usuarioId,
      dataDeCadastro: this.now,
      cnpj: '',
      Razao: '',
      Fantasia: '',
      erros: [],
      PesoManual: false
    }
  },
  methods: {
    Voltar() {
      this.$router.push('/clientes/1')
    },
    GetCliente() {
      if (this.clienteId == null) return
      var vm = this
      this.$http({ url: '/cliente/editar/' + this.$route.params.id + "/" + this.$store.getters.getAutenticacao.contaId, method: 'GET' })
        .then(response => {
          vm.cnpj = response.data.cnpj
          vm.Razao = response.data.nomeCliente
          vm.Fantasia = response.data.fantasiaCliente
          vm.PesoManual = response.data.pesoManual
        })
        .catch(err => {
          this.$router.push('/500')
        })
    },
    InserirOuEditar() {
      if (this.clienteId != null) {
        this.Editar()
        return
      }

      this.Inserir()
    },
    Editar() {
      var vm = this
      this.$http({ url: '/cliente/editar', data: this.ClienteViewModel, method: 'PUT' })
        .then(response => {
          if (!response.data.sucesso) {
            vm.erros = response.data.erros
            vm.$refs.botaoSalvar.unloading()
            return
          }
          this.$store.commit("set_mensagem", { tipo: "success", mensagem: "O cliente foi editado com sucesso!" })
          this.$router.push('/clientes/1')
        })
        .catch(err => {
          this.$store.commit("set_mensagem", { tipo: "danger", mensagem: err.response.data.errors })
          this.$router.push('/clientes/1')
        })
    },
    Inserir() {
      var vm = this
      this.$http({ url: '/cliente/novo', data: this.ClienteViewModel, method: 'POST' })
        .then(response => {
          if (!response.data.sucesso) {
            vm.erros = response.data.erros
            vm.$refs.botaoSalvar.unloading()
            return
          }
          this.$store.commit("set_mensagem", { tipo: "success", mensagem: "O cliente foi salvo com sucesso!" })
          this.$router.push('/clientes/1')
        })
        .catch(err => {
          this.$store.commit("set_mensagem", { tipo: "danger", mensagem: err.response.data.errors })
          this.$router.push('/clientes/1')
        })
    },
  },
}
</script>